import { config } from '../config.js';
import { query } from '../Query/Query.js';
import { Feature } from './Feature.js';
import { range } from './range.js';

var width = function width(min, max) {
  return new Feature(range('width', config.width[min] + config.unit, typeof max === 'string' ? config.width[max] + config.unit : max));
};
var m = query(width('m', false));
var l = query(width('l', false));
var xl = query(width('xl', false));
var maxM = query(width('m', true));
var maxL = query(width('l', true));
var maxXl = query(width('xl', true));

export { l, m, maxL, maxM, maxXl, width, xl };
//# sourceMappingURL=width.js.map
